import { useEffect, useState } from 'react'
import { fetchSpartacusPresets } from 'src/utils/spartacusApi'

export function useSpartacusPresets() {
  const [presets, setPresets] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    async function loadPresets() {
      setLoading(true)
      setError(null)

      try {
        const data = await fetchSpartacusPresets()
        if (!cancelled) {
          setPresets(data)
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load presets')
          setPresets([])
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    loadPresets()

    return () => {
      cancelled = true
    }
  }, [])

  return { presets, loading, error }
}
